/**
 * Called by vuex stores in case of exceptions/errors.
 *
 * @param error
 */
export const errorHandler = (error) => {
    // TODO: emit an event indicating login failure
    console.error(error);
    alert(error.message);
};

